export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '推荐信列表';
